import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, EventEmitter, Output, NgModule } from '@angular/core';
import { BehaviorSubject, of, forkJoin, EMPTY, Subject } from 'rxjs';
import { environment } from 'environment-configurations';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { map, take, catchError, takeUntil } from 'rxjs/operators';
import { CustomErrorToastComponent } from 'custom-error-toast';
import { saveAs } from 'file-saver';
import * as i1$1 from '@angular/common/http';
import * as i2$2 from 'ngx-toastr';
import * as i1$2 from '@angular/router';
import * as i2$1 from 'app-services-library';
import * as i4 from 'ngx-permissions';
import * as i1$3 from '@ng-idle/core';
import { DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i8 from 'angular-file';
import { ngfModule } from 'angular-file';
import * as i3$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';

class SimpleFileUploadService {
    constructor() { }
}
SimpleFileUploadService.ɵfac = function SimpleFileUploadService_Factory(t) { return new (t || SimpleFileUploadService)(); };
SimpleFileUploadService.ɵprov = i0.ɵɵdefineInjectable({ token: SimpleFileUploadService, factory: SimpleFileUploadService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SimpleFileUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-button", "", 1, "btn", "btn-secondary", 3, "click"], ["mat-raised-button", "", "color", "primary", 1, "btn", "btn-primary", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
    } }, directives: [i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i3.MatButton], styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}input.update-dialog[_ngcontent-%COMP%]{border:.5px solid #d2d2d2;border-radius:.2em;height:34px}.message[_ngcontent-%COMP%]{border-top:2px dashed grey;padding-top:15px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:10px;border-radius:20px;cursor:pointer;font-size:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2.Store }]; }, null); })();

class UploadDocumentService {
    constructor(http) {
        this.http = http;
        this.uploaded$ = new BehaviorSubject({});
        this.deletedfile$ = new BehaviorSubject({});
    }
    // uploadDocument(beneficiaryId: number, categoryName: string, entityId: number, fileCategory: string, payload) {
    //   return this.http.post(`/document/beneficiary/${beneficiaryId}/category/${categoryName}/entity/${entityId}/fileCategory/${fileCategory}`, payload).pipe(
    //     map((response: ImagilityBaseResponse) => {
    //       console.log(response);
    //       return response;
    //     })
    //   );
    // }
    // getUploadDocument(beneficiaryId: number, categoryName: string) {
    //   return this.http.get(`/document/beneficiary/${beneficiaryId}/category/${categoryName}`).pipe(
    //     map((response) => response)
    //   );
    // }
    // deleteUploadDocument(beneficiaryId: number, categoryName: string, fileCategory: string, fileId: number) {
    //   return this.http.delete(`/document/benficiary/${beneficiaryId}/category/${categoryName}/fileCategory/${fileCategory}/${fileId}`).pipe(
    //     map((response) => response)
    //   )
    // }
    genericUploadDocument(useCase, useCaseId, categoryName, entityId, fileCategory, otherName, payload, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? (appendUrl ? '&' : '?') + `familyId=${familyId}` : '';
        return this.http.post(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entityId}/fileCategory/${fileCategory}${appendUrl}${profileFamilyString}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    generiBankUploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId, containerId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/upload/bankDetails/${empId}/category/${categoryName}/fileCategory/${fileCategory}/bId/${containerId}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericW4UploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/w4formsupload/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericForm16UploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/form16upload/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericBankGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId, bId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/fbUploadedDocs/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}/bId/${bId}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericW4GetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/fbW4UploadedDocs/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericDeleteUploadDocument(useCase, useCaseId, categoryName, fileCategory, fileId, entityId, useEntityId, isEntityBasedDelete) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const fileIdTobePassed = (isEntityBasedDelete) ? '' : fileId;
        return this.http.delete(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}/fileCategory/${fileCategory}/${fileIdTobePassed}`).pipe(map((response) => {
            this.uploaded();
            return response;
        }));
    }
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    deleteBankFileFromDocumentList(Id) {
        return this.http.delete(`/formBuilder/delete/bankDetailsDocument/${Id}`).pipe(map((data) => {
            this.deletefile(Id);
            return data;
        }));
    }
    deleteW4FileFromDocumentList(empId, categoryName, fileCategory) {
        return this.http.delete(`/formBuilder/employee/w4Details/delete/${empId}/category/${categoryName}/fileCategory/${fileCategory}`).pipe(map((data) => {
            this.deletefile(empId);
            return data;
        }));
    }
    getEntitySpecificUploadDocument(useCase, useCaseId, categoryName, entity) {
        // console.log(entity);
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entity}`).pipe(map((response) => response));
    }
    uploaded() {
        this.uploaded$.next(true);
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
}
UploadDocumentService.ɵfac = function UploadDocumentService_Factory(t) { return new (t || UploadDocumentService)(i0.ɵɵinject(i1$1.HttpClient)); };
UploadDocumentService.ɵprov = i0.ɵɵdefineInjectable({ token: UploadDocumentService, factory: UploadDocumentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadDocumentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.HttpClient }]; }, null); })();

class ImagilityWebStorage {
    constructor(router, sessionRelatedServiceService) {
        this.router = router;
        this.sessionRelatedServiceService = sessionRelatedServiceService;
        this.reloadSubject = new BehaviorSubject(false);
        this.reloadTrigger = this.reloadSubject.asObservable();
    }
    setWebStorageItem(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
    getWebStorageItem(key) {
        return JSON.parse(sessionStorage.getItem(key));
    }
    removeWebStorageItem(key) {
        sessionStorage.removeItem(key);
    }
    /*IM3069*/
    startLocalstorageEventListening() {
        window.addEventListener("storage", this.storageEventListener.bind(this));
    }
    storageEventListener(event) {
        if (event.target.hasOwnProperty('localStorage') && event.key == 'session_end') {
            localStorage.setItem('UserToken', null);
            localStorage.setItem('userTypeRole', null);
            this.sessionRelatedServiceService.clearSessionStorage();
            this.router.navigate(['/login']);
        }
        if (event.target.hasOwnProperty('localStorage') && localStorage.getItem('UserToken') !== 'null' && event.key == 'UserToken') {
            if (sessionStorage.getItem('currentUser') && sessionStorage.getItem('currentUser') !== 'null') {
                if (localStorage.getItem('UserToken') !== JSON.parse(sessionStorage.getItem('currentUser'))['jwt']) {
                    this.reloadSubject.next(true);
                }
            }
        }
    }
    stopLocalstorageEventListening() {
        window.removeEventListener("storage", this.storageEventListener.bind(this));
    }
    sessionEndTimestamping() {
        let timestamp = new Date().getTime();
        localStorage.setItem('session_end', timestamp.toString());
    }
}
ImagilityWebStorage.ɵfac = function ImagilityWebStorage_Factory(t) { return new (t || ImagilityWebStorage)(i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(i2$1.SessionRelatedServiceService)); };
ImagilityWebStorage.ɵprov = i0.ɵɵdefineInjectable({ token: ImagilityWebStorage, factory: ImagilityWebStorage.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImagilityWebStorage, [{
        type: Injectable,
        args: [{ 'providedIn': 'root' }]
    }], function () { return [{ type: i1$2.Router }, { type: i2$1.SessionRelatedServiceService }]; }, null); })();

class IdleService {
    constructor(idle) {
        this.idle = idle;
        this.state = 0 /* ACTIVE */;
        this.timedOut = false;
        this.noTimeOut = new Set(['/error/time-out', '/login']);
    }
    set(idleTime, timeoutTime) {
        this.idle.setIdle(idleTime);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        this.idle.setTimeout(timeoutTime);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    }
    get() {
        return this.idle;
    }
    getState() {
        return this.state;
    }
    reset() {
        this.idle.watch();
        this.state = 0 /* ACTIVE */;
        this.timedOut = false;
    }
}
IdleService.ɵfac = function IdleService_Factory(t) { return new (t || IdleService)(i0.ɵɵinject(i1$3.Idle)); };
IdleService.ɵprov = i0.ɵɵdefineInjectable({ token: IdleService, factory: IdleService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$3.Idle }]; }, null); })();

class AuthenticationService {
    constructor(router, http, webStorage, permissionsService, idleService, sessionRelatedServiceService) {
        this.router = router;
        this.http = http;
        this.webStorage = webStorage;
        this.permissionsService = permissionsService;
        this.idleService = idleService;
        this.sessionRelatedServiceService = sessionRelatedServiceService;
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
        this.domainName = window.location.host;
        const regexExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi;
        let footerNameString = regexExp.test(this.domainName);
        if (footerNameString == false && this.domainName == 'imagility.co' || footerNameString == true || footerNameString == false && this.domainName == 'localhost:4200') {
            this.domainName = 'imagility.co';
        }
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    // public jwtHelper: JwtHelperService = new JwtHelperService(); // temp fix - don't delete
    login(payload) {
        //  let domainName = this.domainName;
        payload = Object.assign(Object.assign({}, payload), { domainName: this.domainName });
        // this.http = this.http.disableJwt();
        return this.http.post(`/authenticate`, payload)
            .pipe(map((user) => {
            if (user && user.status === 200) {
                if (user.data['linkRequestCode'] == null ||
                    user.data['linkRequestCode'] == null) {
                    this.mapUserData(user);
                }
            }
            else {
                sessionStorage.setItem('attemptedUserName', payload.username);
                sessionStorage.setItem('userId', user.data['userId']);
            }
            return user;
        }));
    }
    loginCheck(username, password) {
        let domainName = this.domainName;
        return this.http.post(`/authenticate`, { username, password, domainName }).pipe(map((user) => {
            return user;
        }));
    }
    loginExternalBeneficiary(username, password, linkRequestCode) {
        return this.http.post(`/authenticate/link`, { linkRequestCode, password, username })
            .pipe(map((user) => {
            return user;
        }));
    }
    logout() {
        const token = localStorage.getItem('UserToken');
        if (token && token !== 'null') {
            return this.http.post(`/authenticate/invalidate`, {
                'jwt': 'Bearer ' + token
            });
        }
        else {
            return of(null);
        }
    }
    setCookie(jwt) {
        document.cookie = '';
        const d = new Date();
        d.setTime(d.getTime() + (3600 * 1000 * 24 * 365 * 1));
        const expires = 'expires=' + d.toUTCString();
        // document.cookie = "UserAcceptanceCookie=1;path=/;domain=imagility.com;" + expires;
        document.cookie = 'UserToken=' + jwt + ';path=/;';
    }
    validateUser(token) {
        let domainName = this.domainName;
        if (token && token !== 'null') {
            const jwt = 'Bearer ' + token;
            let payload = { jwt, domainName };
            if ('presentApp' in sessionStorage) {
                payload = Object.assign(Object.assign({}, payload), { appName: sessionStorage.getItem('presentApp') });
            }
            return this.http.post(`/authenticate`, payload)
                .pipe(map((user) => {
                if (user && user.status === 200) {
                    this.mapUserData(user);
                    return user;
                }
                else {
                    return of(null);
                }
            }), catchError(error => {
                this.logout()
                    .pipe(take(1))
                    .subscribe(() => {
                    this.clearUserData();
                    this.router.navigate(['/login']);
                });
                throw error;
            }));
        }
        return of(null);
    }
    mapUserData(user) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        sessionStorage.setItem('isCredentialsExpired', user['isCredentialsExpired']);
        this.webStorage.setWebStorageItem('currentUser', user.data);
        localStorage.setItem('UserToken', user.data ? user.data['jwt'] : null);
        localStorage.setItem('userTypeRole', user.data ? user.data['userType'] : null);
        sessionStorage.setItem('companyId', user.data ? user.data['companyId'] : null);
        sessionStorage.setItem('userId', user.data ? user.data['userId'] : null);
        sessionStorage.setItem('employeeId', user.data ? user.data['employeeId'] : null);
        sessionStorage.setItem('loginEmployeeId', user.data ? user.data['employeeId'] : null);
        sessionStorage.setItem('beneficiaryId', user.data && user.data['beneficiaryId'] ? user.data['beneficiaryId'] : ('wizardTID' in sessionStorage && 'wizardTIDbeneficiaryId' in sessionStorage ? sessionStorage.getItem('wizardTIDbeneficiaryId') : (sessionStorage.getItem('beneficiaryId') ? sessionStorage.getItem('beneficiaryId') : null)));
        sessionStorage.setItem('loggedInBeneficiaryId', user.data ? user.data['beneficiaryId'] : null);
        sessionStorage.setItem('avatar', user.data ? (user.data['profileSmallImage']) ? user.data['profileSmallImage'] : undefined : undefined);
        sessionStorage.setItem('userTypeRole', user.data ? user.data['userType'] : null);
        sessionStorage.setItem('userTypeId', user.data ? user.data['userId'] : null);
        sessionStorage.setItem('roleName', (_b = (_a = user.data) === null || _a === void 0 ? void 0 : _a.roleName) !== null && _b !== void 0 ? _b : null);
        this.permissionsService.loadPermissions(user.data ? user.data['permissions'] : []);
        if (((_d = (_c = user === null || user === void 0 ? void 0 : user.data) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            sessionStorage.setItem('isFBUser', 'true');
            sessionStorage.setItem('fbEmpId', user.data.fbEmployeeId ? user.data.fbEmployeeId : null);
            sessionStorage.setItem('fbModuleList', JSON.stringify(user.data.modules));
            sessionStorage.setItem('fbDesignation', user.data.designation ? user.data.designation : '');
            sessionStorage.setItem('isFbHrManager', user.data.isFbHrManager);
            sessionStorage.setItem('fbRole', (_f = (_e = user.data) === null || _e === void 0 ? void 0 : _e.roleName) !== null && _f !== void 0 ? _f : null);
        }
        sessionStorage.setItem('roleList', ((_h = (_g = user.data) === null || _g === void 0 ? void 0 : _g.roles) === null || _h === void 0 ? void 0 : _h.length) > 0 ? JSON.stringify(user.data.roles) : '[]');
        this.currentUserSubject.next(user.data);
    }
    clearUserData() {
        localStorage.setItem('UserToken', null);
        localStorage.setItem('userTypeRole', null);
        if ('currentUser' in sessionStorage) {
            this.webStorage.removeWebStorageItem('currentUser');
        }
        if ('presentApp' in sessionStorage) {
            this.webStorage.removeWebStorageItem('presentApp');
        }
        this.currentUserSubject.next(null);
        this.webStorage.sessionEndTimestamping(); /*IM3069*/
        this.sessionRelatedServiceService.clearSessionStorage();
        this.idleService.get().stop();
    }
    logoCalling(url) {
        return this.http.get(`/company/logo/` + url).pipe(map((response) => {
            return response;
        }));
    }
}
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(ImagilityWebStorage), i0.ɵɵinject(i4.NgxPermissionsService), i0.ɵɵinject(IdleService), i0.ɵɵinject(i2$1.SessionRelatedServiceService)); };
AuthenticationService.ɵprov = i0.ɵɵdefineInjectable({ token: AuthenticationService, factory: AuthenticationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.Router }, { type: i1$1.HttpClient }, { type: ImagilityWebStorage }, { type: i4.NgxPermissionsService }, { type: IdleService }, { type: i2$1.SessionRelatedServiceService }]; }, null); })();

class ReferenceLibraryService {
    constructor(http, authenticationService) {
        this.http = http;
        this.authenticationService = authenticationService;
    }
    requestDataFromMultipleSources() {
        let response1 = this.http.get(`/referenceLibrary/ADDR`);
        let response2 = this.http.get(`/referenceLibrary/MARSTAT`);
        let response3 = this.http.get(`/referenceLibrary/PHON`);
        let response4 = this.http.get(`/referenceLibrary/EMLTYP`);
        let response5 = this.http.get(`/referenceLibrary/GENDER`);
        let response6 = this.http.get(`/referenceLibrary/TITL`);
        let response7 = this.http.get(`/referenceLibrary/MARSTAT`);
        let response8 = this.http.get(`/referenceLibrary/RACE`);
        let response9 = this.http.get(`/referenceLibrary/FAMRELTYP`);
        let response10 = this.http.get(`/referenceLibrary/CTZNACQRTYP`);
        let response11 = this.http.get(`/referenceLibrary/ETHNICITY`);
        return forkJoin([response1, response2, response3, response4, response5, response6, response7, response8, response9, response10, response11]);
    }
    getReferenceData(referenceCode) {
        if (this.authenticationService.currentUserValue) {
            return this.http.get(`/referenceLibrary/${referenceCode}`).pipe(map((response) => {
                if (response.status === 200) {
                    return response.data;
                }
            }));
        }
        else {
            return EMPTY;
        }
    }
    getReferenceDataWithoutAuthentication(referenceCode) {
        return this.http.get(`/referenceLibrary/${referenceCode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getGroupReferenceData(groupReferenceCode) {
        return this.http.get(`/referenceLibrary/${groupReferenceCode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    postReferenceData(payload) {
        if (this.authenticationService.currentUserValue) {
            return this.http.post(`/referenceLibrary/`, payload).pipe(map((response) => {
                if (response.status === 200) {
                    return response.data;
                }
            }));
        }
        else {
            return EMPTY;
        }
    }
    getReferencePaymentModeData(referenceCode) {
        if (this.authenticationService.currentUserValue) {
            return this.http.get(`/referenceLibrary/${referenceCode}`).pipe(map((response) => {
                if (response.status === 200) {
                    return response.data;
                }
            }));
        }
        else {
            return EMPTY;
        }
    }
}
ReferenceLibraryService.ɵfac = function ReferenceLibraryService_Factory(t) { return new (t || ReferenceLibraryService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(AuthenticationService)); };
ReferenceLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ReferenceLibraryService, factory: ReferenceLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReferenceLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.HttpClient }, { type: AuthenticationService }]; }, null); })();

class UnsubscribeSubcriptionService {
    constructor() { }
    onUnSubscribe(subcriptions) {
        subcriptions.forEach(subcription => {
            if (subcription) {
                subcription.unsubscribe();
            }
        });
    }
}
UnsubscribeSubcriptionService.ɵfac = function UnsubscribeSubcriptionService_Factory(t) { return new (t || UnsubscribeSubcriptionService)(); };
UnsubscribeSubcriptionService.ɵprov = i0.ɵɵdefineInjectable({ token: UnsubscribeSubcriptionService, factory: UnsubscribeSubcriptionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UnsubscribeSubcriptionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

//IM-2472 - Download button opens file instead of download
function FileDownloadComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵlistener("click", function FileDownloadComponent_a_0_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.download(); });
    i0.ɵɵelementStart(1, "mat-icon", 2);
    i0.ɵɵtext(2, "get_app");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class FileDownloadComponent {
    constructor(http) {
        this.http = http;
    }
    ngOnInit() {
    }
    download() {
        this.http.get(this.Path, { responseType: "arraybuffer" }).subscribe(pdf => {
            var blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, this.fileName);
        });
    }
}
FileDownloadComponent.ɵfac = function FileDownloadComponent_Factory(t) { return new (t || FileDownloadComponent)(i0.ɵɵdirectiveInject(i1$1.HttpClient)); };
FileDownloadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FileDownloadComponent, selectors: [["app-file-download"]], inputs: { fileName: "fileName", Path: "Path" }, decls: 1, vars: 1, consts: [[3, "click", 4, "ngIf"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "Download Document", 1, "material-icons"]], template: function FileDownloadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FileDownloadComponent_a_0_Template, 3, 0, "a", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.fileName);
    } }, directives: [i6.NgIf, i3$1.MatIcon, i4$1.MatTooltip], styles: ["a[_ngcontent-%COMP%]{color:#505050;text-decoration:none;background-color:transparent}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDownloadComponent, [{
        type: Component,
        args: [{
                selector: 'app-file-download',
                templateUrl: './file-download.component.html',
                styleUrls: ['./file-download.component.scss']
            }]
    }], function () { return [{ type: i1$1.HttpClient }]; }, { fileName: [{
            type: Input
        }], Path: [{
            type: Input
        }] }); })();

function SimpleFileUploadComponent_ng_template_0_div_0_div_1_select_4_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", type_r15.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", type_r15.name, " ");
} }
function SimpleFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 15, 16);
    i0.ɵɵlistener("ngModelChange", function SimpleFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(4); return ctx_r16.fileCategory = $event; })("change", function SimpleFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template_select_change_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(4); return ctx_r18.setOtherNameEmpty(); });
    i0.ɵɵelementStart(2, "option", 17);
    i0.ɵɵtext(3, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SimpleFileUploadComponent_ng_template_0_div_0_div_1_select_4_option_4_Template, 2, 2, "option", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngModel", ctx_r11.fileCategory);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.documentTypes);
} }
function SimpleFileUploadComponent_ng_template_0_div_0_div_1_input_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 20);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", ctx_r12.selectedDocType);
} }
function SimpleFileUploadComponent_ng_template_0_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "label", 12);
    i0.ɵɵtext(3, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SimpleFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template, 5, 2, "select", 13);
    i0.ɵɵtemplate(5, SimpleFileUploadComponent_ng_template_0_div_0_div_1_input_5_Template, 1, 1, "input", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r7.documentTypes == null ? null : ctx_r7.documentTypes.length) > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r7.documentTypes == null ? null : ctx_r7.documentTypes.length) == 1);
} }
function SimpleFileUploadComponent_ng_template_0_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "label");
    i0.ɵɵtext(2, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 22);
    i0.ɵɵlistener("ngModelChange", function SimpleFileUploadComponent_ng_template_0_div_0_div_2_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.otherName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r8.otherName);
} }
function SimpleFileUploadComponent_ng_template_0_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "button", 23);
    i0.ɵɵlistener("filesChange", function SimpleFileUploadComponent_ng_template_0_div_0_div_4_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return ctx_r21.files = $event; });
    i0.ɵɵtext(3, " Browse ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 24);
    i0.ɵɵtext(5, "Max file size is 10 MB | PDF, PNG, JPG, JPEG file types are allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r9.entityId === 0 || !ctx_r9.fileCategory || ctx_r9.family && !ctx_r9.familyId)("accept", ctx_r9.acceptFileType)("files", ctx_r9.files);
} }
function SimpleFileUploadComponent_ng_template_0_div_0_div_5_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 29);
    i0.ɵɵtext(1, "upload_file");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "w-200": a0 }; };
function SimpleFileUploadComponent_ng_template_0_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "button", 26);
    i0.ɵɵlistener("filesChange", function SimpleFileUploadComponent_ng_template_0_div_0_div_5_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(3); return ctx_r24.files = $event; })("filesChange", function SimpleFileUploadComponent_ng_template_0_div_0_div_5_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(3); return ctx_r26.onFileSelected($event); });
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtemplate(5, SimpleFileUploadComponent_ng_template_0_div_0_div_5_mat_icon_5_Template, 2, 0, "mat-icon", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 24);
    i0.ɵɵtext(9, "Max file size is 10 MB | PDF, PNG, JPG, JPEG file types are allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r10.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r10.entityId === 0 || !ctx_r10.fileCategory || ctx_r10.inputMultipleFlag === null || ctx_r10.inputMultipleFlagFed === null || ctx_r10.inputMultipleFlagState === null || ctx_r10.family && !ctx_r10.familyId || ctx_r10.fileCategory === "OTHER" && ctx_r10.otherName.trim() === "")("accept", ctx_r10.acceptFileType)("files", ctx_r10.files);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r10.buttonOnlyMode);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.singleFileTypeName, " ");
} }
const _c1 = function (a0) { return { "fileDahedBorderBox": a0 }; };
const _c2 = function (a0) { return { "marginTop": a0 }; };
function SimpleFileUploadComponent_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, SimpleFileUploadComponent_ng_template_0_div_0_div_1_Template, 6, 2, "div", 6);
    i0.ɵɵtemplate(2, SimpleFileUploadComponent_ng_template_0_div_0_div_2_Template, 4, 1, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, SimpleFileUploadComponent_ng_template_0_div_0_div_4_Template, 6, 3, "div", 9);
    i0.ɵɵtemplate(5, SimpleFileUploadComponent_ng_template_0_div_0_div_5_Template, 10, 8, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, !ctx_r2.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.documentTypeRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.fileCategory === "OTHER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2, !ctx_r2.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isMultiple);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isMultiple);
} }
function SimpleFileUploadComponent_ng_template_0_ngfFormData_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngfFormData", 30);
    i0.ɵɵlistener("FormDataChange", function SimpleFileUploadComponent_ng_template_0_ngfFormData_1_Template_ngfFormData_FormDataChange_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("files", ctx_r3.files)("FormData", ctx_r3.uploadedFilesData);
} }
function SimpleFileUploadComponent_ng_template_0_div_2_tr_21_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngfBackground", item_r30);
} }
const _c3 = function () { return ["image/gif", "image/png", "image/jpeg"]; };
function SimpleFileUploadComponent_ng_template_0_div_2_tr_21_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtemplate(2, SimpleFileUploadComponent_ng_template_0_div_2_tr_21_div_2_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 38);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 38);
    i0.ɵɵelementStart(11, "div", 39);
    i0.ɵɵelementStart(12, "div", 40);
    i0.ɵɵelementStart(13, "span", 41);
    i0.ɵɵlistener("click", function SimpleFileUploadComponent_ng_template_0_div_2_tr_21_Template_span_click_13_listener() { i0.ɵɵrestoreView(_r35); const i_r31 = ctx.index; const ctx_r34 = i0.ɵɵnextContext(3); return ctx_r34.files.splice(i_r31, 1); });
    i0.ɵɵelement(14, "i", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(7, _c3).indexOf(item_r30.type) >= 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r30.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r30.type, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(9, 4, item_r30.size / 1024 / 1024, ".2"), " MB ");
} }
function SimpleFileUploadComponent_ng_template_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Files To Be Uploaded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32);
    i0.ɵɵelementStart(5, "div", 33);
    i0.ɵɵelementStart(6, "button", 34);
    i0.ɵɵlistener("click", function SimpleFileUploadComponent_ng_template_0_div_2_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.files.length = 0; });
    i0.ɵɵelement(7, "i", 35);
    i0.ɵɵtext(8, " Remove all ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "table", 36);
    i0.ɵɵelementStart(10, "thead");
    i0.ɵɵelementStart(11, "tr");
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵtext(13, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th");
    i0.ɵɵtext(15, "Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17, "Size");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "th");
    i0.ɵɵtext(19, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "tbody");
    i0.ɵɵtemplate(21, SimpleFileUploadComponent_ng_template_0_div_2_tr_21_Template, 15, 8, "tr", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "ngfFormData", 30);
    i0.ɵɵlistener("FormDataChange", function SimpleFileUploadComponent_ng_template_0_div_2_Template_ngfFormData_FormDataChange_22_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", !ctx_r4.files.length);
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", ctx_r4.files);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("files", ctx_r4.files)("FormData", ctx_r4.uploadedFilesData);
} }
function SimpleFileUploadComponent_ng_template_0_div_3_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 49);
    i0.ɵɵtext(1, " Actions ");
    i0.ɵɵelementEnd();
} }
function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 56);
    i0.ɵɵlistener("click", function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r50); const item_r41 = i0.ɵɵnextContext(3).$implicit; const ctx_r48 = i0.ɵɵnextContext(3); return ctx_r48.openDoc(item_r41); });
    i0.ɵɵelementStart(1, "mat-icon", 57);
    i0.ɵɵtext(2, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtemplate(1, SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template, 3, 0, "span", 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r41.fileLocation);
} }
function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelement(1, "app-file-download", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", item_r41.fileLocationName)("Path", ctx_r45.envPath + item_r41.fileLocation.substring(23));
} }
function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelementStart(1, "span", 56);
    i0.ɵɵlistener("click", function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); const i_r42 = ctx_r54.index; const item_r41 = ctx_r54.$implicit; const ctx_r53 = i0.ɵɵnextContext(3); return ctx_r53.deleteFiles(i_r42, item_r41); });
    i0.ɵɵelementStart(2, "mat-icon", 59);
    i0.ɵɵtext(3, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 38);
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵtemplate(2, SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_Template, 2, 1, "div", 53);
    i0.ɵɵtemplate(3, SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_3_Template, 2, 2, "div", 53);
    i0.ɵɵtemplate(4, SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template, 4, 0, "div", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext().$implicit;
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r43.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r41.fileLocation && ctx_r43.isDownloadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r43.isDeleteEnabled);
} }
function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵelementStart(3, "a", 50);
    i0.ɵɵlistener("click", function SimpleFileUploadComponent_ng_template_0_div_3_tr_14_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r58); const item_r41 = ctx.$implicit; const ctx_r57 = i0.ɵɵnextContext(3); return ctx_r57.openDoc(item_r41); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 38);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SimpleFileUploadComponent_ng_template_0_div_3_tr_14_td_10_Template, 5, 3, "td", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = ctx.$implicit;
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r41.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r41.fileCategory.code === "OTHER" ? item_r41.fileCategoryOtherName ? item_r41.fileCategoryOtherName : item_r41.fileCategory.name : item_r41.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(9, 4, item_r41.fileSize / 1024 / 1024, ".2"), " MB");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r40.isViewEnabled || ctx_r40.isDownloadEnabled || ctx_r40.isDeleteEnabled);
} }
function SimpleFileUploadComponent_ng_template_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "h5", 44);
    i0.ɵɵtext(2, "List of Uploaded Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "table", 45);
    i0.ɵɵelementStart(4, "thead");
    i0.ɵɵelementStart(5, "tr");
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "Size");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SimpleFileUploadComponent_ng_template_0_div_3_th_12_Template, 2, 0, "th", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "tbody", 47);
    i0.ɵɵtemplate(14, SimpleFileUploadComponent_ng_template_0_div_3_tr_14_Template, 11, 7, "tr", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngIf", ctx_r5.isViewEnabled || ctx_r5.isDownloadEnabled || ctx_r5.isDeleteEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.listFiles)("ngForTrackBy", ctx_r5.trackItem);
} }
function SimpleFileUploadComponent_ng_template_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2, "No Documents Uploaded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SimpleFileUploadComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SimpleFileUploadComponent_ng_template_0_div_0_Template, 6, 10, "div", 1);
    i0.ɵɵtemplate(1, SimpleFileUploadComponent_ng_template_0_ngfFormData_1_Template, 1, 2, "ngfFormData", 2);
    i0.ɵɵtemplate(2, SimpleFileUploadComponent_ng_template_0_div_2_Template, 23, 4, "div", 3);
    i0.ɵɵtemplate(3, SimpleFileUploadComponent_ng_template_0_div_3_Template, 15, 3, "div", 3);
    i0.ɵɵtemplate(4, SimpleFileUploadComponent_ng_template_0_div_4_Template, 3, 0, "div", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isUploadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.family && ctx_r0.familyId == null && ctx_r0.isFileListRequired && ctx_r0.files && ctx_r0.files.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listFiles && ctx_r0.listFiles.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.listFiles || ctx_r0.listFiles && ctx_r0.listFiles.length === 0);
} }
function SimpleFileUploadComponent_ng_template_1_ngfFormData_0_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngfFormData", 30);
    i0.ɵɵlistener("FormDataChange", function SimpleFileUploadComponent_ng_template_1_ngfFormData_0_Template_ngfFormData_FormDataChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(2); return ctx_r62.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("files", ctx_r59.files)("FormData", ctx_r59.uploadedFilesData);
} }
const _c4 = function (a0) { return { "disabled": a0 }; };
function SimpleFileUploadComponent_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelementStart(1, "button", 64);
    i0.ɵɵlistener("filesChange", function SimpleFileUploadComponent_ng_template_1_div_1_Template_button_filesChange_1_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(2); return ctx_r64.files = $event; })("filesChange", function SimpleFileUploadComponent_ng_template_1_div_1_Template_button_filesChange_1_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(2); return ctx_r66.onFileSelected($event); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 24);
    i0.ɵɵtext(4, "Max file size is 10 MB | PDF, PNG, JPG, JPEG file types are allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4, ctx_r60.entityId === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r60.entityId === 0 || !ctx_r60.fileCategory)("accept", ctx_r60.acceptFileType)("files", ctx_r60.files);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r60.singleFileTypeName);
} }
function SimpleFileUploadComponent_ng_template_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "span", 66);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "app-file-download", 67);
    i0.ɵɵelementStart(4, "mat-icon", 68);
    i0.ɵɵlistener("click", function SimpleFileUploadComponent_ng_template_1_div_2_Template_mat_icon_click_4_listener() { i0.ɵɵrestoreView(_r68); const ctx_r67 = i0.ɵɵnextContext(2); return ctx_r67.deleteFiles(0, ctx_r67.listFiles[0]); });
    i0.ɵɵtext(5, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r61.listFiles[0].fileNameWithExtension);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", ctx_r61.listFiles[0].fileLocation.substring(23))("Path", ctx_r61.envPath + ctx_r61.listFiles[0].fileLocation.substring(23));
} }
function SimpleFileUploadComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SimpleFileUploadComponent_ng_template_1_ngfFormData_0_Template, 1, 2, "ngfFormData", 2);
    i0.ɵɵtemplate(1, SimpleFileUploadComponent_ng_template_1_div_1_Template, 5, 7, "div", 61);
    i0.ɵɵtemplate(2, SimpleFileUploadComponent_ng_template_1_div_2_Template, 6, 3, "div", 62);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.listFiles || ctx_r1.listFiles && ctx_r1.listFiles.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.listFiles && ctx_r1.listFiles.length > 0);
} }
class SimpleFileUploadComponent {
    constructor(uploadDocumentService, toastr, dialog, changeDetectorRef, referenceLibraryService, unsubscribeSubcriptionService) {
        this.uploadDocumentService = uploadDocumentService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.changeDetectorRef = changeDetectorRef;
        this.referenceLibraryService = referenceLibraryService;
        this.unsubscribeSubcriptionService = unsubscribeSubcriptionService;
        this.fileUploadSuccess = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.documentTypes = [];
        this.files = [];
        this.listFiles = [];
        this.categoryName = 'BENEDUDOC';
        this.displayedColumns = ['name', 'documentType', 'size'];
        this.dataSource = [];
        this.fileCategory = '';
        this.otherName = '';
        this.showSpecify = false;
        this.useEntityId = false;
        this.isEntityBasedDelete = false;
        this.selectedDocType = '';
        this.isViewEnabled = true;
        this.isDownloadEnabled = true;
        this.isDeleteEnabled = true;
        this.isUploadEnabled = true; // IM 3926
        this.subcriptions = [];
        this.files = [];
        this.isMultiple = false;
        this.acceptFileType = 'image/*'; // Acceptable types: application/pdf, application/vnd.ms-excel, image/gif, image/jpeg
        this.isFileListRequired = true;
        this.documentTypeRequired = false;
        this.docummentTypeCode = null;
        this.useCase = '';
        this.useCaseId = 0;
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    }
    ngOnInit() {
        this.envPath = environment.docs;
    }
    ngOnChanges(e) {
        if (e.configurations && e.configurations.currentValue) {
            this.isMultiple = false;
            this.singleFileTypeName = e.configurations.currentValue.singleFileTypeName ? e.configurations.currentValue.singleFileTypeName : 'Browse';
            this.buttonOnlyMode = e.configurations.currentValue.buttonOnlyMode ? e.configurations.currentValue.buttonOnlyMode : false;
            this.acceptFileType = e.configurations.currentValue.fileType;
            this.isFileListRequired = e.configurations.currentValue.isFileListRequired;
            this.categoryName = e.configurations.currentValue.categoryName;
            this.entityId = e.configurations.currentValue.entityId;
            this.inputMultipleFlag = e.configurations.currentValue.inputMultipleFlag;
            this.inputMultipleFlagState = e.configurations.currentValue.inputMultipleFlagState;
            this.inputMultipleFlagFed = e.configurations.currentValue.inputMultipleFlagFed;
            this.fileCategory = e.configurations.currentValue.fileCategory;
            this.listFiles = e.configurations.currentValue.listUploadedFiles ?
                e.configurations.currentValue.entityType ?
                    e.configurations.currentValue.listUploadedFiles.filter(x => x[e.configurations.currentValue.entityType] == this.entityId) :
                    e.configurations.currentValue.listUploadedFiles.filter(x => x.entityId == this.entityId) : [];
            this.documentTypeRequired = e.configurations.currentValue.documentTypeRequired;
            this.docummentTypeCode = e.configurations.currentValue.docummentTypeCode;
            this.useCase = e.configurations.currentValue.useCase;
            this.useCaseId = e.configurations.currentValue.useCaseId;
            this.useEntityId = (e.configurations.currentValue.useEntityId) ? e.configurations.currentValue.useEntityId : false;
            this.isEntityBasedDelete = (e.configurations.currentValue.isEntityBasedDelete) ?
                e.configurations.currentValue.isEntityBasedDelete : false;
            this.isViewEnabled = (e.configurations.currentValue.isViewEnabled === false) ? false : true;
            this.isDownloadEnabled = (e.configurations.currentValue.isDownloadEnabled === false) ? false : true;
            this.listFiles = this.listFiles.map((_e) => {
                _e.fileLocationName = (this.isFBUser && _e.fileLocation) ? _e.fileLocation.split('/').slice(-1)[0] : _e.fileLocation.substring(23);
                return _e;
            });
            this.isDeleteEnabled = (e.configurations.currentValue.isDeleteEnabled === false) ? false : true;
            this.isUploadEnabled = (e.configurations.currentValue.isUploadEnabled === false) ? false : true;
            this.petitionOutcomeId = e.configurations.currentValue.petitionOutcomeId ? e.configurations.currentValue.petitionOutcomeId : null;
            this.singleButtonUpload = e.configurations.currentValue.singleButtonUpload ? e.configurations.currentValue.singleButtonUpload : false;
            this.familyId = e.configurations.currentValue.familyId ? e.configurations.currentValue.familyId : null;
            this.family = e.configurations.currentValue.family ? e.configurations.currentValue.family : false;
            if (this.docummentTypeCode) {
                if (this.documentTypeRequired) {
                    this.fileCategory = '';
                }
                // this.fileCategory = '';
                this.getDocumentTypeList();
            }
            // Refresh the To be uploaded files list
            if (this.fileCategory === '') {
                this.files = [];
            }
        }
    }
    getDocumentTypeList() {
        this.subcriptions[this.subcriptions.length] =
            this.referenceLibraryService.getReferenceDataWithoutAuthentication(this.docummentTypeCode)
                .subscribe((response) => {
                if (this.petitionOutcomeId) {
                    switch (this.petitionOutcomeId) {
                        case 'APPROVED':
                            this.documentTypes = response.filter(x => x.code === 'APPROVAL');
                            break;
                        case 'RFE':
                            this.documentTypes = response.filter(x => x.code === 'RFE');
                            break;
                        case 'NOID':
                            this.documentTypes = response.filter(x => x.code === 'NOID');
                            break;
                        case 'DENIED':
                            this.documentTypes = response.filter(x => x.code === 'DENIAL');
                            break;
                        case 'PETWITHDRAW':
                            this.documentTypes = response.filter(x => x.code === 'WITHDRWACK' || x.code === 'WITHDRAW');
                            break;
                        case 'GET_RECEIPT':
                            this.documentTypes = response.filter(x => x.code === 'RECNOTC');
                            break;
                        default:
                            this.documentTypes = response;
                            break;
                    }
                }
                else {
                    this.documentTypes = response;
                }
                if (this.documentTypes && this.documentTypes.length === 1) {
                    this.fileCategory = this.documentTypes[0].code;
                    this.selectedDocType = this.documentTypes[0].name;
                }
                else {
                    this.selectedDocType = '';
                }
            });
    }
    uploadFiles() {
        if (this.documentTypeRequired) {
            if (this.fileCategory) {
                if (this.files[this.files.length - 1].size <= 10485760) {
                    if (this.categoryName === 'BANKDETAILSDOC' || this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE' || this.categoryName === 'FORM16DETAILSDOC') {
                        this.uploadFinancials();
                    }
                    else if (this.categoryName !== 'BENGREENCARD') {
                        this.uploadDocument();
                    }
                    else {
                        if (this.family && this.familyId == null) {
                            console.log('No Beneficiary ID');
                        }
                        else {
                            this.uploadDocument();
                        }
                    }
                }
                else {
                    this.files = [];
                    CustomErrorToastComponent.showErrorToast(this.toastr, 'File Size is > 10MB');
                }
            }
            else {
                this.files = [];
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Select a document type');
            }
        }
        else {
            if (this.files[this.files.length - 1].size <= 10485760) {
                this.uploadDocument();
            }
            else {
                this.files = [];
                CustomErrorToastComponent.showErrorToast(this.toastr, 'File Size is > 10MB');
            }
        }
    }
    uploadDocument() {
        this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.fileCategory, this.otherName, this.uploadedFilesData, this.familyId)
            .subscribe(response => {
            if (response.status === 200) {
                this.fileUploadSuccess.emit();
                this.toastr.success(response.message, 'Success');
                this.files = [];
                //setting Document Type Name(Other field) empty
                this.setOtherNameEmpty();
                // if the html have dropdown for selecting the catagory only we clear the fileCategory
                if (this.documentTypeRequired && !this.selectedDocType) {
                    this.fileCategory = '';
                }
                this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.useEntityId, this.familyId)
                    .subscribe((responseGetUploadDocument) => {
                    if (responseGetUploadDocument.status === 200) {
                        this.listFiles =
                            responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                .map(x => {
                                return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                            });
                        // Bcz entity Id is sometime alphanumeric
                        // this code was added for only LCA Withdrawn
                        if (this.fileCategory === 'LCAWTDOC') {
                            this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                return e;
                            });
                        }
                        this.changeDetectorRef.detectChanges();
                    }
                    if (responseGetUploadDocument.status === 204) {
                        this.listFiles = [];
                        this.changeDetectorRef.detectChanges();
                    }
                });
            }
            else {
                // this.toastr.error(response['message']);
                if (this.documentTypeRequired && !this.selectedDocType) {
                    this.fileCategory = '';
                }
                this.files = [];
            }
        });
    }
    uploadFinancials() {
        if (this.categoryName === 'BANKDETAILSDOC') {
            this.uploadDocumentService.generiBankUploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId, this.containerId)
                .subscribe(response => this.handleBankUploadResponse(response));
        }
        else if (this.categoryName === 'FORM16DETAILSDOC') {
            this.uploadDocumentService.genericForm16UploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleW4UploadResponse(response));
        }
        else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
            this.uploadDocumentService.genericW4UploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleW4UploadResponse(response));
        }
    }
    handleBankUploadResponse(response) {
        if (response.status === 200) {
            this.fileUploadSuccess.emit();
            this.toastr.success(response.message, 'Success');
            this.inputMultipleFlag = null;
            this.files = [];
            // Setting Document Type Name(Other field) empty
            this.setOtherNameEmpty();
            // If the HTML has dropdown for selecting the category only, clear the fileCategory
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericBankGetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId, this.containerId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles =
                        responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                            .map(x => {
                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                        });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.changeDetectorRef.detectChanges();
                }
            });
        }
        else {
            // this.toastr.error(response['message']);
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.files = [];
        }
    }
    handleW4UploadResponse(response) {
        if (response.status === 200) {
            this.fileUploadSuccess.emit();
            this.toastr.success(response.message, 'Success');
            this.inputMultipleFlagState = null;
            this.inputMultipleFlagFed = null;
            this.files = [];
            // Setting Document Type Name(Other field) empty
            this.setOtherNameEmpty();
            // If the HTML has dropdown for selecting the category only, clear the fileCategory
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericW4GetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles =
                        responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                            .map(x => {
                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                        });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.changeDetectorRef.detectChanges();
                }
            });
        }
        else {
            // this.toastr.error(response['message']);
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.files = [];
        }
    }
    deleteFiles(index, item) {
        const title = 'Confirm';
        const message = 'Do you wish to Delete the File?';
        this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
            if (result) {
                if (this.categoryName !== 'BANKDETAILSDOC' && this.categoryName !== 'W4FORMS' && this.categoryName !== 'W4FORMSSTATE') {
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericDeleteUploadDocument(this.useCase, this.useCaseId, item.fileCategory.group, item.fileCategory.code, item.id, this.entityId, this.useEntityId, this.isEntityBasedDelete)
                        .subscribe((response) => {
                        if (response.status === 200) {
                            this.fileUploadSuccess.emit();
                            this.toastr.success(response.message, 'Success');
                            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.useEntityId, this.familyId)
                                .subscribe((responseGetUploadDocument) => {
                                if (responseGetUploadDocument.status === 200) {
                                    this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                        .map(x => {
                                        return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                    });
                                    this.changeDetectorRef.detectChanges();
                                }
                                if (responseGetUploadDocument.status === 204) {
                                    this.listFiles = [];
                                    this.changeDetectorRef.detectChanges();
                                }
                            });
                        }
                        else {
                            CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
                        }
                    });
                }
                if (this.categoryName === 'BANKDETAILSDOC') {
                    this.deleteBankDocumentHandler(item);
                }
                else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
                    this.deleteW4DocumentHandler(item);
                }
            }
        });
    }
    openDoc(item) {
        const docPath = item.fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    trackItem(index, item) {
        return item.id;
    }
    dialogueInitializer(title, message) {
        // const cordinates: MouseEventInit = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
                update: { title, message },
                buttons: ['Cancel', 'Delete']
            }
        });
        return dialogRef;
    }
    deleteBankDocumentHandler(item) {
        this.uploadDocumentService.deleteBankFileFromDocumentList(item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.toastr.success(data.message, 'Success');
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericBankGetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId, this.containerId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                        .map(x => {
                        return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                    });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.inputMultipleFlag = true;
                    this.changeDetectorRef.detectChanges();
                }
            });
        });
    }
    deleteW4DocumentHandler(item) {
        this.uploadDocumentService.deleteW4FileFromDocumentList(this.configurations.entityId, this.categoryName, this.fileCategory).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.toastr.success(data.message, 'Success');
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericW4GetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                        .map(x => {
                        return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                    });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.inputMultipleFlagFed = true;
                    this.inputMultipleFlagState = true;
                    this.changeDetectorRef.detectChanges();
                }
            });
        });
    }
    onFileSelected(e) {
        if (e && e.length > 0) {
            setTimeout(() => {
                this.uploadFiles();
            }, 500);
        }
    }
    setOtherNameEmpty() {
        this.otherName = '';
    }
    ngOnDestroy() {
        this.subcriptions.forEach(subscription => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
    }
}
SimpleFileUploadComponent.ɵfac = function SimpleFileUploadComponent_Factory(t) { return new (t || SimpleFileUploadComponent)(i0.ɵɵdirectiveInject(UploadDocumentService), i0.ɵɵdirectiveInject(i2$2.ToastrService), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ReferenceLibraryService), i0.ɵɵdirectiveInject(UnsubscribeSubcriptionService)); };
SimpleFileUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SimpleFileUploadComponent, selectors: [["lib-simple-file-upload"]], inputs: { configurations: "configurations", containerId: "containerId" }, outputs: { fileUploadSuccess: "fileUploadSuccess" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "ngIf"], ["class", "row", 3, "ngClass", 4, "ngIf"], ["postName", "file", 3, "files", "FormData", "FormDataChange", 4, "ngIf"], ["class", "pt-2", "style", "margin-bottom: 40px", 4, "ngIf"], ["class", "pt-2 text-center", "style", "margin-bottom: 40px", 4, "ngIf"], [1, "row", 3, "ngClass"], ["class", "col-4 mt-1", 4, "ngIf"], ["class", "col-4 form-group", 4, "ngIf"], [1, "col-4", 3, "ngClass"], [4, "ngIf"], [1, "col-4", "mt-1"], [1, "form-group"], [1, "label-cls", "d-block"], ["class", "im-input mt-2 mw-100 d-block", "name", "fileCategoryType", "required", "", 3, "ngModel", "ngModelChange", "change", 4, "ngIf"], ["type", "text", "class", "im-input mt-2 mw-100 d-block", "readonly", "", 3, "value", 4, "ngIf"], ["name", "fileCategoryType", "required", "", 1, "im-input", "mt-2", "mw-100", "d-block", 3, "ngModel", "ngModelChange", "change"], ["fileCategoryType", "ngModel"], ["value", ""], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["type", "text", "readonly", "", 1, "im-input", "mt-2", "mw-100", "d-block", 3, "value"], [1, "col-4", "form-group"], ["type", "text", 1, "im-input", 3, "ngModel", "ngModelChange"], ["type", "button", "multiple", "1", "ngfSelect", "", 1, "im-btn", "im-btn-md", "im-btn-primary", 3, "disabled", "accept", "files", "filesChange"], [1, "label-cls", "single-file-upload", "d-block"], [1, "form-group", "mb-0", 3, "ngClass"], ["type", "button", "ngfSelect", "", 1, "btn-primary", "im-btn-md", "im-btn-primary", 3, "disabled", "accept", "files", "filesChange"], [1, "btnModeBtnContent"], ["class", "material-icons", 4, "ngIf"], [1, "material-icons"], ["postName", "file", 3, "files", "FormData", "FormDataChange"], [1, "pt-2", 2, "margin-bottom", "40px"], [1, "d-flex", "flex-row-reverse"], [1, "p-2"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-sm", 3, "disabled", "click"], ["aria-hidden", "true", 1, "fa", "fa-trash"], [1, "im-card-no-border-table"], [4, "ngFor", "ngForOf"], ["nowrap", ""], [1, "d-flex", "flex-row"], [1, "p-2", "padding0"], ["title", "Remove", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-trash", "fa-lg", "icn"], [1, "previewIcon", 3, "ngfBackground"], [1, "heading"], [1, "im-card-no-border-table", "file-upload-list", "table-striped-simple"], ["class", "text-center", 4, "ngIf"], [1, "wrap-word"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "text-center"], [2, "cursor", "pointer", 3, "click"], ["nowrap", "", 4, "ngIf"], [1, "d-flex", "flex-row", "align-items-center", "justify-content-center"], ["class", "mr-2 padding0", 4, "ngIf"], [1, "mr-2", "padding0"], [3, "click", 4, "ngIf"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons"], [3, "fileName", "Path"], ["matTooltipClass", "tooltip-bg", "matTooltip", "Delete Document", 1, "material-icons"], [1, "pt-2", "text-center", 2, "margin-bottom", "40px"], ["class", "d-inline-block", 3, "ngClass", 4, "ngIf"], ["class", "d-inline-block", "class", "single-fileuploaded-view-holder", 4, "ngIf"], [1, "d-inline-block", 3, "ngClass"], ["type", "button", "matTooltipClass", "tooltip-bg", "ngfSelect", "", 1, "btn", "btn-outline-primary", "single-file-upload", 3, "disabled", "accept", "files", "filesChange"], [1, "single-fileuploaded-view-holder"], [1, "file-uploaded"], [1, "ml-3", "pr-2", 3, "fileName", "Path"], ["matTooltip", "Delete Document", "matTooltipClass", "tooltip-bg", 1, "material-icons", 3, "click"]], template: function SimpleFileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SimpleFileUploadComponent_ng_template_0_Template, 5, 5, "ng-template", 0);
        i0.ɵɵtemplate(1, SimpleFileUploadComponent_ng_template_1_Template, 3, 3, "ng-template", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.singleButtonUpload);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.singleButtonUpload);
    } }, directives: [i6.NgIf, i6.NgClass, i7.SelectControlValueAccessor, i7.RequiredValidator, i7.NgControlStatus, i7.NgModel, i7.NgSelectOption, i7.ɵangular_packages_forms_forms_z, i6.NgForOf, i7.DefaultValueAccessor, i8.ngfSelect, i3$1.MatIcon, i8.ngfFormData, i8.ngfBackground, i4$1.MatTooltip, FileDownloadComponent], pipes: [i6.DecimalPipe], styles: [".marginTop[_ngcontent-%COMP%]{padding:30px 10px}.fileDahedBorderBox[_ngcontent-%COMP%]{border:1px dashed #d3d3d3;margin-bottom:10px}.padding0[_ngcontent-%COMP%]{padding:0!important}.file-upload-list[_ngcontent-%COMP%]{width:100%}.error[_ngcontent-%COMP%]{font-size:12px;color:red}.required[_ngcontent-%COMP%]{font-size:14px;color:red}.mb-minus-2-5[_ngcontent-%COMP%]{margin-top:-1.2em}.title-head[_ngcontent-%COMP%]{font-weight:700;color:#333}.list-font[_ngcontent-%COMP%]{font-size:.9em}.hint-text[_ngcontent-%COMP%]{color:#000;font-size:12px;font-weight:700;line-height:20px}.w-200[_ngcontent-%COMP%]{width:200px!important}.btnModeBtnContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center;align-items:center}.single-file-upload.btn-outline-primary[_ngcontent-%COMP%]{height:35px;font-weight:600!important;padding:0 15px!important}.single-file-upload.label-cls[_ngcontent-%COMP%]{font-size:12px;margin-bottom:-12px!important}.single-fileuploaded-view-holder[_ngcontent-%COMP%]{margin-top:14px}.single-fileuploaded-view-holder[_ngcontent-%COMP%]   .file-uploaded[_ngcontent-%COMP%]{width:190px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:24px;display:inline-block;padding-right:15px;border-right:1px solid #a3a6b4}.file-upload-list[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{height:50px!important;text-transform:uppercase!important}.wrap-word[_ngcontent-%COMP%]{word-break:break-all}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SimpleFileUploadComponent, [{
        type: Component,
        args: [{
                selector: 'lib-simple-file-upload',
                templateUrl: './simple-file-upload.component.html',
                styleUrls: ['./simple-file-upload.component.scss']
            }]
    }], function () { return [{ type: UploadDocumentService }, { type: i2$2.ToastrService }, { type: i1.MatDialog }, { type: i0.ChangeDetectorRef }, { type: ReferenceLibraryService }, { type: UnsubscribeSubcriptionService }]; }, { configurations: [{
            type: Input
        }], fileUploadSuccess: [{
            type: Output
        }], containerId: [{
            type: Input
        }] }); })();

class SimpleFileUploadModule {
}
SimpleFileUploadModule.ɵfac = function SimpleFileUploadModule_Factory(t) { return new (t || SimpleFileUploadModule)(); };
SimpleFileUploadModule.ɵmod = i0.ɵɵdefineNgModule({ type: SimpleFileUploadModule });
SimpleFileUploadModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatTableModule,
            FormsModule,
            ReactiveFormsModule,
            MatListModule,
            MatButtonModule,
            MatButtonToggleModule,
            MatExpansionModule,
            MatTooltipModule,
            MatFormFieldModule,
            MatIconModule,
            MatDialogModule,
            MatDividerModule,
            ngfModule,
            MatInputModule,
            MatSelectModule,
            TimelineModule,
            CardModule,
            ButtonModule,
            DialogModule,
            FileUploadModule,
            TableModule,
            TabViewModule,
            ConfirmDialogModule,
            DropdownModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SimpleFileUploadModule, { declarations: [SimpleFileUploadComponent, ConfirmationModalComponent, FileDownloadComponent], imports: [CommonModule,
        MatTableModule,
        FormsModule,
        ReactiveFormsModule,
        MatListModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatExpansionModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatIconModule,
        MatDialogModule,
        MatDividerModule,
        ngfModule,
        MatInputModule,
        MatSelectModule,
        TimelineModule,
        CardModule,
        ButtonModule,
        DialogModule,
        FileUploadModule,
        TableModule,
        TabViewModule,
        ConfirmDialogModule,
        DropdownModule], exports: [SimpleFileUploadComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SimpleFileUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [SimpleFileUploadComponent, ConfirmationModalComponent, FileDownloadComponent],
                imports: [
                    CommonModule,
                    MatTableModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatListModule,
                    MatButtonModule,
                    MatButtonToggleModule,
                    MatExpansionModule,
                    MatTooltipModule,
                    MatFormFieldModule,
                    MatIconModule,
                    MatDialogModule,
                    MatDividerModule,
                    ngfModule,
                    MatInputModule,
                    MatSelectModule,
                    TimelineModule,
                    CardModule,
                    ButtonModule,
                    DialogModule,
                    FileUploadModule,
                    TableModule,
                    TabViewModule,
                    ConfirmDialogModule,
                    DropdownModule,
                ],
                exports: [SimpleFileUploadComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of simple-file-upload
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SimpleFileUploadComponent, SimpleFileUploadModule, SimpleFileUploadService };
//# sourceMappingURL=simple-file-upload.js.map
